import { render, staticRenderFns } from "./RightFirst.vue?vue&type=template&id=505476c8"
import script from "./RightFirst.vue?vue&type=script&lang=js"
export * from "./RightFirst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports